import * as documentApiSagas from './documentApi/documentApiSagas';
import * as documentAsideSagas from './documentAside/documentAsideSagas';
import * as newDocumentListSagas from './documentList/newDocumentListStateSagas';
import * as documentSpecificSagas from './documentSpecific/documentSpecificSagas';
import { watchDocumentChangesSaga } from './documentUI/documentChangesSagas';
import { documentUISaga } from './documentUI/documentUISagas';
import * as externalDataSagas from './externalData/externalDataSagas';
import * as facetSagas from './externalData/sharedItemFacetsSagas';
import * as versionsSagas from './externalData/versionsSagas';
import * as llinkidSagas from './llinkid/llinkidSagas';
import { pendingActionsSaga } from './pendingActions/pendingActionsSagas';
import * as previewSagas from './preview/previewSagas';
import * as referenceFramesSagas from './referenceFrames/referenceFramesSagas';
import * as userSagas from './user/userSagas';
import * as validationSaga from './validation/validationSagas';
import { zillSaga } from './zill/zillSagas';
import { documentSnapshotSaga } from './documentSnapshot/documentSnapshotSagas';

function initSagas(sagaMiddleware) {
  Object.values(newDocumentListSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(documentApiSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(documentAsideSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(userSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(externalDataSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(referenceFramesSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(previewSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  sagaMiddleware.run(zillSaga);
  sagaMiddleware.run(documentUISaga);
  sagaMiddleware.run(pendingActionsSaga);
  Object.values(validationSaga).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(llinkidSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(versionsSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(facetSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  Object.values(documentSpecificSagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
  sagaMiddleware.run(watchDocumentChangesSaga);
  sagaMiddleware.run(documentSnapshotSaga);
}

export default initSagas;
